import { NETWORK_BADGE, NETWORK_LABELS } from "./constants";

/**
 * Compact feed-network chip rendered inline with the brand name.
 * Uses nowrap so multi-word labels (e.g. PubAdHub Kevin) stay inside
 * the pill instead of wrapping out of a fixed-height box.
 */
export default function NetworkBadge({ network }) {
  if (!network) return null;
  const key = String(network).toLowerCase();
  const cls = NETWORK_BADGE[key] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      className={`inline-flex items-center max-w-full py-0.5 px-1.5 text-[9px] font-bold uppercase tracking-wide whitespace-nowrap leading-none rounded border ${cls}`}
      data-testid={`brand-network-badge-${key}`}
    >
      {NETWORK_LABELS[key] || network}
    </span>
  );
}
